import React from "react";

const InactivityTrackerWrapper = ({ children }) => {
  // useEffect(() => {
  //   setupInactivityTracker();
  // }, []);

  return <>{children}</>;
};

export default InactivityTrackerWrapper;
